'use client';

import { useEffect, useState } from 'react';

export default function StickyCta() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className={`sticky-cta ${visible ? '' : 'hidden-cta'}`}>
      <a
        href="https://www.hvacservicespro.com"
        target="_blank"
        rel="noopener noreferrer"
        className="btn-primary flex items-center gap-2.5 px-5 py-3.5 rounded-2xl text-sm font-bold shadow-amber"
      >
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 12l2 2 4-4"/>
          <path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"/>
        </svg>
        Free Estimate
      </a>
    </div>
  );
}